import { useEffect, useState } from 'react';
import { errorToast } from '../../../utils/helper';
import { getWorkoutStats, getRecipeStats } from '../../../api/healthAPI';
import FitnessStats from '../../../component/HealthComponent/FitnessStats';
import NutritionStats from '../../../component/HealthComponent/NutritionStats';
import Loader from '../../../component/common/Loader';

const HealthDashboard = () => {
  const [fitnessStats, setFitnessStats] = useState(null);
  const [nutritionStats, setNutritionStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const [workoutRes, recipeRes] = await Promise.all([getWorkoutStats(), getRecipeStats()]);
      if (workoutRes?.meta?.code === 1) setFitnessStats(workoutRes.data);
      if (recipeRes?.meta?.code === 1) setNutritionStats(recipeRes.data);
    } catch (error) {
      errorToast(error.message || 'Failed to load dashboard stats');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative lg:mb-[45px]">
      {loading ? (
        <Loader />
      ) : (
        <div className="mt-4">
          <FitnessStats stats={fitnessStats} />
          <NutritionStats stats={nutritionStats} />
        </div>
      )}
    </div>
  );
};

export default HealthDashboard;
